import styled, { keyframes } from "styled-components";

export const Container = styled.div<{
  $isScrolled?: boolean;
  $isMenuClosed?: boolean;
}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  overflow: ${({ $isScrolled }) => ($isScrolled ? "scroll" : "")};
  overflow-x: ${({ $isScrolled }) => ($isScrolled ? "scroll" : "clip")};
  height: 100vh;
  color: #58585a;
  font-family: Arial, sans-serif;
  padding-bottom: 70px;
  padding-top: ${({ $isScrolled }) => ($isScrolled ? "28vh" : "66vh")};
  padding-left: 150px;
  padding-right: 150px;
  transition: padding-top 0.7s ease;
  @media (max-height: 720px) {
    padding-top: ${({ $isScrolled }) => ($isScrolled ? "32vh" : "72vh")};
  }
  @media (max-width: 1073px) {
    padding: 20% 20px 75px 20px;
    padding-top: ${({ $isMenuClosed }) => (!$isMenuClosed ? "60%" : "20%")};
    transition: padding-top 0.1s ease;
  }
`;

export const PreText = styled.p`
  font-size: 1.2rem;
  color: #58585a;
  margin: 15px 0;
  line-height: 1.5;
  text-align: center;
`;

export const MainContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  @media (max-width: 1073px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const ImageContainer = styled.div<{ $isScrolled?: boolean }>`
  position: relative;
  width: 400px; /* Nastav šířku kontejneru podle potřeby */
  height: 200px; /* Nastav výšku kontejneru podle potřeby */
  margin-top: -50px; /* Zajistí překrytí boxu s textem */
  opacity: ${({ $isScrolled }) => ($isScrolled ? 1 : 0)};
  transform: ${({ $isScrolled }) =>
    $isScrolled ? "translateX(0)" : "translateX(-100%)"};
  transition: transform 0.5s ease-out, opacity 0.5s ease-out;
  @media (max-width: 1073px) {
    width: 100%;
    height: auto;
    margin-top: 0; /* Zruší překrytí na menších obrazovkách */
    transform: none; /* Zruší posun na menších obrazovkách */
    opacity: 1; /* Zajistí, že obrázky budou viditelné na menších obrazovkách */
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;

export const Image = styled.img`
  position: absolute;
  width: 400px; /* Nastav šířku obrázku podle potřeby */
  height: auto;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* Přidá stín pro efekt koláže */
  transition: transform 0.3s ease; /* Přechod pro plynulou animaci při najetí myší */

  @media (min-width: 1074px) {
    &:nth-child(1) {
      right: -20%;
      top: 40px;
      transform: rotate(-5deg);
    }

    &:nth-child(2) {
      left: -50px;
      top: 300px;
    }

    &:nth-child(3) {
      right: 450px;
      top: 265px;
      transform: rotate(5deg);
    }
  }
  &:hover {
    transform: scale(1.05); /* Mírné zvětšení při najetí myší */
    @media (max-width: 768px) {
      transform: none; /* Zruší zvětšení na menších obrazovkách */
    }
  }

  @media (max-width: 1073px) {
    position: relative; /* Zruší absolutní pozicování na menších obrazovkách */
    width: 80%;
    height: auto;
    margin-top: 15px; /* Zruší překrytí na menších obrazovkách */
    transform: none; /* Zruší posun na menších obrazovkách */
    transition: none; /* Zruší přechod na menších obrazovkách */
    top: 0; /* Zruší posun nahoru na menších obrazovkách */
    right: 0; /* Zruší posun doprava na menších obrazovkách */
    left: 0; /* Zruší posun doleva na menších obrazovkách */
  }
`;

export const ListContainer = styled.div<{ $isScrolled?: boolean }>`
  font-size: 1.2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px 40px 20px 20px;
  background-color: #f1ebdd;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  position: relative;
  opacity: ${({ $isScrolled }) => ($isScrolled ? 1 : 0)};
  transform: ${({ $isScrolled }) =>
    $isScrolled ? "translateX(0)" : "translateX(100%)"};
  transition: transform 0.5s ease-out, opacity 0.5s ease-out;
  @media (max-width: 1073px) {
    width: 100%;
    height: auto;
    padding: 20px;
    margin-top: 0; /* Zruší překrytí na menších obrazovkách */
    transform: none; /* Zruší posun na menších obrazovkách */
    opacity: 1; /* Zajistí, že obrázky budou viditelné na menších obrazovkách */
  }
`;

export const TextList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const ListItem = styled.li`
  list-style: none; /* Odstraní výchozí odrážku */
  position: relative;
  padding-left: 30px; /* Přidá prostor pro vlastní odrážku */
  line-height: 1.5;
  @media (max-width: 1225px) {
    padding-right: 100px;
  }
  &:not(:last-child) {
    margin-bottom: 15px; /* Přidá prostor mezi položkami */
  }
  &::before {
    content: ">>"; /* Nastaví obsah odrážky */
    color: #34b54b; /* Nastaví barvu odrážky */
    position: absolute;
    left: 0;
    top: 0;
  }
  @media (max-width: 1073px) {
    line-height: 2;
    padding-right: 0;
  }
`;

const bounce = keyframes`
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-15px);
  }
`;

export const FixedArrow = styled.img<{
  $isScrolled?: boolean;
}>`
  width: 200px;
  position: fixed;
  bottom: 0; /* Nastaví vzdálenost od dolního okraje */
  left: calc(50% - 100px); /* Vycentruje obrázek horizontálně */
  animation: ${bounce} 1s infinite; /* Nekonečná smyčka animace */
  display: ${({ $isScrolled }) => ($isScrolled ? "none" : "block")};
  cursor: pointer;
  @media (max-width: 768px) {
    display: none; /* Skryje šipku na menších obrazovkách */
  }
`;
